import "./SingleDot.scss";

function SingleDots() {
  return <div className="dot-style"></div>;
}

export default SingleDots;
